const initialState = JSON.parse(localStorage.getItem('donationSubscriptionResponse') || "{}")

const donationSubscriptionResponse = (state = initialState, action) => {
  // console.log({action, state})
  if (action.type === "SET_DONATION_SUBSCRIPTION_RESPONSE") {
    const { donationSubscriptionResponse } = action.payload

    localStorage.setItem('donationSubscriptionResponse', JSON.stringify(donationSubscriptionResponse))
    return donationSubscriptionResponse
  }
  else {
    return state
  }

}

export default donationSubscriptionResponse;
